import { Dictionary } from "lodash";

export class UsuarioBaseTO {
    subscriptionId: string;
    nome: string;
    sobrenome: string;
    email: string;
    headline?: string;
    tagsInteressesPrincipais?: string[];
    tagsInteressesDetalhes?: string[];
    userTempPwd?: string;
    googleToken?: string;
    facebookToken?: string;
    skills?: string[];
    customFields?: Dictionary<string>;
    dataReviewedAt?: string;
    groups?: string[];
    requestPasswordChange?: Date;
    passwordChangedAt?: Date;
}
